module.exports = __webpack_public_path__ + "static/img/time-range.4a869bcb.svg";